export default __webpack_public_path__ + "static/media/php-logo.8a27be18.svg";